/* eslint-disable prefer-named-capture-group */
export const dependsOnModelRegex = '^([a-zA-Z0-9]*-[a-zA-Z0-9_]*)$';
export const dependsOnValuesRegex = '^([a-zA-Z0-9_]*)$';
export const onChangeFunctionRegex = /^[a-zA-Z0-9]*\([a-zA-Z0-9-_, ]*\)$/;


export const vatRates = [
  { value: '0', label: '0%' },
  { value: '5', label: '5%' },
  { value: '8', label: '8%' },
  { value: '23', label: '23%' },
  { value: 'np', label: 'np' },
  { value: 'zw', label: 'zw' },
  { value: 'vz', label: 'vz' }
];

export const invoiceTypes = [
  { name: 'Paragon', code: 5 },
  { name: 'Paragon korygujący', code: 6 },
  { name: 'Faktura', code: 1 },
  { name: 'Faktura korygująca', code: 2 },
  { name: 'Faktura proforma', code: 3 },
  { name: 'Faktura do paragonu', code: 4 },
  { name: 'Faktura marża', code: 7 },
  { name: 'Paragon marża', code: 8 },
  { name: 'Faktura do paragonu marża', code: 9 },
  { name: 'Faktura zaliczkowa', code: 10 },
  { name: 'Nota obciążeniowa', code: 11 }
];
